import Converter from '../../../../../functions/Converter';
import ContinerPrice from './ContinerPrice';


export default ({data, click_select_flight, specialTime}) => {

    return (
    <div className="special-flight">
        { data.map((value, key) => 

        {
            let style = {'animationDelay': `${0}s`}
            let check = value['p_before'] || value['p_after'] || value['time'] || value['place'];
            
            return <>
            <div onDoubleClick={() => click_select_flight([value['key'], ...value['flight'], value['price']])} >
                { check &&
                <div className="special-animation">
                    <div className="special-flight-p"> </div>
                    <p style={style}>
                        <span> { value['p_before'] } </span>
                        <span> { value['time'] ? specialTime[value['key']] : value['place'] ? value['place'] : '' } </span>
                        <span> { value['p_after'] } </span>
                    </p>
                    <div className="special-flight-p">  </div>
                </div>
                }

                <div key={key}>
                    {
                        value['flight'].map((valueFlight, keyFlight) => <p key={keyFlight}> {valueFlight} </p>)
                    }
                    <p key={value['flight'].length}> 
                        <ContinerPrice 
                            price={value['price']}
                            r_price={value['r_price']}
                            places={value['places']}
                        />
                    </p>
                </div>
            </div> 
            </>
        })}
    </div>
    )
}